import { UPDATE_USER_RESIDENCY_INFO } from '../actions/actionTypes';

import {
  STREET_ADDRESS,
  APT_UNIT,
  CITY,
  STATE,
  ZIP_CODE,
  OWN_RENT,
  rent,
  LIVE_DURATION,
  YEARS,
  MONTHS,
  MONTHLY_PAYMENT,
  NY,
  RESIDENCY_STATE_OPTIONS,
} from '../constants/Dashboard/Residency';

const DEFAULT_STATE = {
  [STREET_ADDRESS]: '',
  [APT_UNIT]: '',
  [CITY]: '',
  [STATE]: NY,
  [ZIP_CODE]: '',
  [OWN_RENT]: rent,
  [LIVE_DURATION]: {
    [YEARS]: 2,
    [MONTHS]: 0,
  },
  [MONTHLY_PAYMENT]: '',
};

export const residencyReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case UPDATE_USER_RESIDENCY_INFO:
      const allDisplayStates = RESIDENCY_STATE_OPTIONS.map((option) => option.text);
      if (allDisplayStates.includes(action.payload[STATE])) {
        const valueObj = RESIDENCY_STATE_OPTIONS.find(
          (option) => option.text === action.payload[STATE],
        );
        return {
          ...state,
          ...action.payload,
          [STATE]: valueObj.value,
        };
      }

      const startDate = new Date(action.payload.startDate);
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      const startDateMonth = startDate.getMonth();

      const currentYear = currentDate.getFullYear();
      const startDateYear = startDate.getFullYear();

      let monthDiff = currentMonth - startDateMonth;
      let yearDiff = currentYear - startDateYear;

      if (monthDiff < 0) {
        yearDiff = yearDiff - 1;
        monthDiff = monthDiff + 12;
      }

      const duration = {
        [YEARS]: yearDiff,
        [MONTHS]: monthDiff,
      };

      return {
        ...state,
        ...action.payload,
        [LIVE_DURATION]: duration,
      };

    default:
      return {
        ...state,
      };
  }
};
